import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import EditIcon from "../../../../../../../assets/images/researcher_app/overview/pencil_edit_icon.png";
import InfoIcon from '../../../../../../../assets/images/info_icon_2.png';

import { PrimaryButton } from "../../common_components/Buttons";
import { useAlert } from "react-alert";

// API Calls
import CompanyUserNotesAPI from "../../../api/api_calls/CompanyUserNotesAPI";


function UserDemographics(props) {
    return (
        <UserSubsection >
            <UserSubsectionTitle title="Demographics" />
            <div className="info-answer-container">
                <UserInfoRow key={"Name"} question={"First Name or Pseudonym:"} answer={props.firstName} />

                {<PopulateUserInfoRows {...props} />
                }
            </div>
        </UserSubsection>
    )
}

function PopulateUserInfoRows(props) {
    return (
        <>
            {props.userDemographics &&
                Object.keys(props.userDemographics).map((key, index) => {
                    const answer = props.userDemographics[key] == null ? "No response" : props.userDemographics[key].toString()
                    const style = (answer == "No" || answer == "No response") ? { color: '#7c7c7c' } : null;
                    return (
                        <UserInfoRow key={index} question={key} answer={answer} answerStyle={style} />
                    )
                })
            }
        </>
    )
}

function CryptoUsage(props) {
    return (
        <UserSubsection >
            <UserSubsectionTitle title="Crypto Usage" />
            <div className="info-answer-container">
                {props.cryptoUsage &&
                    Object.keys(props.cryptoUsage).map((key, index) => {
                        var answer = props.cryptoUsage[key] == null ? "No response" : props.cryptoUsage[key]
                        answer = typeof answer == "boolean" ? (answer ? "Yes" : "No") : answer.toString()
                        const style = (answer == "No" || answer == "No response") ? { color: '#7c7c7c' } : null;
                        return (
                            <UserInfoRow key={index} question={key} answer={answer} answerStyle={style} />
                        )
                    }
                    )
                }
            </div>
        </UserSubsection>
    )
}

function UserNotes(props) {
    const navigate = useNavigate();
    const alert = useAlert();

    const [editing, setEditing] = useState(false)
    const [notes, setNotes] = useState(props.userNote ? (props.userNote.note ? props.userNote.note : "") : "")
    const noteId = props.userNote ? props.userNote.id : null
    const userId = props.user.id

    const userNotesTooltip = "Add any notes about this user here by clicking the pencil icon. These notes are specific to your company. You and other researchers will see them when viewing this user."

    useEffect(() => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }, [])

    function handleEditClick() {
        setEditing(prevEditing => !prevEditing)
    }

    function handleNotesChange(e) {
        setNotes(e.target.value)
    }

    function handleSaveClick(e) {
        async function updateNote() {
            const result = await CompanyUserNotesAPI.update({ note_id: noteId, note: notes, handleRedirect: navigate });

            if (result.success) {
                alert.show("Note saved", { type: 'success' })
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        async function createNote() {
            const result = await CompanyUserNotesAPI.create({ user_id: userId, note: notes, handleRedirect: navigate });
            if (result.success) {
                alert.show("Note saved", { type: 'success' })
                props.setUserNote(result.company_user_note)
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        setEditing(false)
        if (noteId) {
            updateNote()
        } else {
            createNote()
        }
    }

    return (
        <UserSubsection >
            <UserSubsectionTitle title="Your User Notes" tooltip={userNotesTooltip} />
            <div className="user-notes-container">
                <textarea className="user-notes-textarea" rows={4} value={notes} disabled={!editing} onChange={handleNotesChange} />
                <div className="edit-icon-and-button-container">
                    <div className="edit-icon-container" onClick={handleEditClick}>
                        <img src={EditIcon} className="edit-icon" />
                    </div>
                    {editing && <PrimaryButton text="Save" onClick={handleSaveClick} />}
                </div>
            </div>
        </UserSubsection>
    )
}

function UserWallets(props) {
    return (
        <UserSubsection >
            <UserSubsectionTitle title="Wallet Addresses" />
            <div className="info-answer-container">
                {props.userWallets && props.userWallets.length > 0 ?
                    props.userWallets.map((wallet, index) => {
                        return (
                            <UserInfoRow key={index} question={wallet.blockchain} answer={wallet.address} />
                        )
                    })
                    :
                    <UserInfoRow question="Wallets" answer="No wallets connected" answerStyle={{ color: '#7c7c7c' }} />
                }
            </div>
        </UserSubsection>
    )
}

function OtherApplications(props) {
    return (
        <UserSubsection >
            <UserSubsectionTitle title="Other Applications" />
            <div className="other-applications-container">
                <ApplicationTitleRow />
                {props.otherApplications.length == 0 ?
                    <div className="application-row">
                        <div className="application-text">
                            No other applications
                        </div>
                    </div>
                    : props.otherApplications.map((app, index) => {
                        return (
                            <ApplicationRow key={index} application={app} />
                        )
                    })}
            </div>
        </UserSubsection>
    )
}


// --------------------------------------------
// --------------------------------------------
// ------------------Supporting------------------
// --------------------------------------------
// --------------------------------------------

function UserSubsection(props) {
    return (
        <div className="user-subsection">
            {props.children}
        </div>
    )
}

function UserSubsectionTitle(props) {
    return (
        <div className="user-subsection-title-row">
            <div className="user-subsection-title">
                {props.title}
            </div>
            {props.tooltip && <img className="px-2" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
        </div>
    )
}

function UserInfoRow(props) {
    return (
        <div className="info-row">
            <div className="info-question">
                {props.question}
            </div>
            <div className="info-answer" style={props.answerStyle}>
                {props.answer}
            </div>
        </div>
    )
}

function ApplicationTitleRow(props) {
    return (
        <div className="application-title-row">
            <div className="application-title-text">
                Project
            </div>
            <div className="application-title-text right">
                Status
            </div>
        </div>
    )
}

function ApplicationRow(props) {
    const statusMap =
    {
        "applied": "Applied",
        "rejected": "Rejected",
        "completed": "Completed",
        "in_review": "In Review",
        "prescreen": "Pre-screen",
        "scheduled": "Scheduled",
    }

    return (
        <div className="application-row ">
            <div className="application-text">
                {props.application.mission_name}
            </div>
            <div className="application-text right">
                {statusMap[props.application.status]}
            </div>
        </div>
    )

}


export { UserDemographics, CryptoUsage, UserWallets, UserNotes, OtherApplications }